(() => {
  'use strict';

  function initGallery(root) {
    if (root.dataset.rfV5GalleryReady === '1') return;
    const dialog = root.querySelector('[data-rf-v5-gallery-dialog]');
    const image = root.querySelector('[data-rf-v5-gallery-main]');
    const items = [...root.querySelectorAll('[data-rf-v5-gallery-item]')];
    const counter = root.querySelector('[data-rf-v5-gallery-counter]');
    if (!dialog || !image || !items.length) return;
    root.dataset.rfV5GalleryReady = '1';
    let index = 0;
    let opener = null;
    let touchStart = null;

    function show(next) {
      index = (next + items.length) % items.length;
      const selected = items[index];
      const url = selected.dataset.rfV5GalleryFull;
      if (image.getAttribute('src') !== url) image.src = url;
      image.alt = selected.dataset.rfV5GalleryAlt || '';
      counter.textContent = (index + 1) + ' / ' + items.length;
      items.forEach((item, position) => {
        item.setAttribute('aria-pressed', String(position === index));
      });
      selected.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }

    root.addEventListener('click', event => {
      const open = event.target.closest('[data-rf-v5-gallery-open]');
      if (open && root.contains(open)) {
        opener = open;
        dialog.showModal();
        show(Number(open.dataset.rfV5GalleryIndex || 0));
        dialog.querySelector('[data-rf-v5-gallery-close]')?.focus();
        return;
      }
      if (!dialog.open) return;
      if (event.target.closest('[data-rf-v5-gallery-close]')) dialog.close();
      if (event.target.closest('[data-rf-v5-gallery-previous]')) show(index - 1);
      if (event.target.closest('[data-rf-v5-gallery-next]')) show(index + 1);
      const thumb = event.target.closest('[data-rf-v5-gallery-item]');
      if (thumb) show(items.indexOf(thumb));
    });

    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (opener?.isConnected) opener.focus();
    });
    const stage = dialog.querySelector('.rf-v5-ab-gallery__stage');
    stage?.addEventListener('touchstart', event => {
      const touch = event.changedTouches[0];
      touchStart = { x: touch.clientX, y: touch.clientY };
    }, { passive: true });
    stage?.addEventListener('touchend', event => {
      if (!touchStart) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - touchStart.x;
      const dy = touch.clientY - touchStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) show(index + (dx < 0 ? 1 : -1));
      touchStart = null;
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-rf-v5-ab-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
